import DAboutFirstBlockEuroBox from './DAboutFirstBlockEuroBox'

export default DAboutFirstBlockEuroBox
